module.exports = __webpack_public_path__ + "static/media/budgetme.a6e1f559.png";